const IMPLICIT_END_CALL_TOOL_ID = "alpharun:end_call";
const IMPLICIT_END_CALL_TOOL_NAME = "end_call";
const IMPLICIT_END_CALL_TOOL_DISPLAY_NAME = "End call";
const IMPLICIT_END_CALL_TOOL_DESCRIPTION = "Ends the call and hangs up. Only use this once the conversation has reached its natural conclusion, or once you have finished leaving a voicemail message. Say goodbye in a preamble message before calling this tool.";
function buildImplicitEndCallAgentTool() {
  return {
    id: IMPLICIT_END_CALL_TOOL_ID,
    name: IMPLICIT_END_CALL_TOOL_NAME,
    description: IMPLICIT_END_CALL_TOOL_DESCRIPTION,
    parameters: { type: "object", properties: {}, additionalProperties: false },
    strict: true,
    // Say goodbye before hanging up, which also lets the caller interrupt and
    // cancel the tool call.
    should_wait_for_playout: true
  };
}
export {
  IMPLICIT_END_CALL_TOOL_DESCRIPTION,
  IMPLICIT_END_CALL_TOOL_DISPLAY_NAME,
  IMPLICIT_END_CALL_TOOL_ID,
  IMPLICIT_END_CALL_TOOL_NAME,
  buildImplicitEndCallAgentTool
};
//# sourceMappingURL=implicitEndCallTool.js.map
